exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".searchbox[data-v-63b48f2a]{width:100%;font-size:40px;border:none;border-bottom:1px solid #000;-webkit-appearance:none;-moz-appearance:none;appearance:none;border-radius:0;outline:none}.searchbox[data-v-63b48f2a]:active,.searchbox[data-v-63b48f2a]:focus{outline:none;border:none;border-bottom:1px solid #000}.img[data-v-63b48f2a]{max-width:300px;max-height:300px}.column[data-v-63b48f2a]{width:80%;margin:0 10%}", ""]);

// exports
